import { BrowserRouter as Router, Route, Routes, Navigate } from "react-router-dom";
import React, { useEffect, useState, Suspense } from "react";
import { useMyContext } from './components/Provider/CommonProvider';
import AutoLogin from "./components/Signin/AutoLogin";
import axios from 'axios'
import Layout from "./layout/layout";
import Dashboard from "./Pages/Dashboard/Dashboard";
import Dashboard_Partner from "./Pages/Dashboard/Dashboard_Partner";
// import MainPage from "./components/MainPage/MainPage";
import Signin from "./components/Signin/Signin";
import Main from "./Pages/Content_Libraries/Main";
import ContentVideo from "./Pages/Content_Libraries/ContentVideo";
import ContentLive from "./Pages/Content_Libraries/ContentLive";
import ContentAudio from "./Pages/Content_Libraries/ContentAudio";
import ContentSeries from "./Pages/Content_Libraries/ContentSeries";
import Media_Library from "./Pages/Content_Libraries/Media_Library";
import View_Media_Library from "./Pages/Content_Libraries/View_Media_Library";
import Allvideo from "./Pages/Video/Video_Management/Allvideo";
import Videoforapproval from "./Pages/Video/Video_Management/Videoforapproval";
import Mastervideolist from "./Pages/Video/Video_Management/Mastervideolist";
import Videoschedule from "./Pages/Video/Video_Management/Videoschedule";
import AddVideoschedule from "./Pages/Video/Video_Management/AddVideoschedule";
import EditVideoschedule from "./Pages/Video/Video_Management/EditVideoschedule";
import Manageschedule from "./Pages/Video/Video_Management/Manageschedule";
import Managevideocategories from "./Pages/Video/Video_Management/Managevideocategories";
import AddManagevideocategories from "./Pages/Video/Video_Management/AddManagevideocategories";
import EditVideotag from "./Pages/Video/Video_Management/EditVideotag";
import AddNewLiveStream from "./Pages/Live Stream/Management_Live_Stream/AddNewLiveStream";
import AllLiveStream from "./Pages/Live Stream/Management_Live_Stream/AllLiveStream";
import ManageLiveCategories from "./Pages/Live Stream/Management_Live_Stream/ManageLiveCategories";
import LiveEventArtist from "./Pages/Live Stream/Management_Live_Stream/LiveEventArtist";
import AddLiveEventArtist from "./Pages/Live Stream/Management_Live_Stream/AddLiveEventArtist";
import EditLiveEventArtist from "./Pages/Live Stream/Management_Live_Stream/EditLiveEventArtist";
import SeriesList from "./Pages/Video/Series&Episode/SeriesList";
import ManageSeries from "./Pages/Video/Series&Episode/ManageSeries";
import AudioList from "./Pages/Audio/Audio_Management/AudioList";
import Addnewaudio from "./Pages/Audio/Audio_Management/Addnewaudio";
import Editnewaudio from "./Pages/Audio/Audio_Management/Editnewaudio";
import Updatesong_Writer from "./Pages/Audio/Audio_Management/Updatesong_Writer";
import StoreSong_Writer from "./Pages/Audio/Audio_Management/StoreSong_Writer";
import Manageaudiocategories from "./Pages/Audio/Audio_Management/Manageaudiocategories";
import Managealbum from "./Pages/Audio/Audio_Management/Managealbum";
import ManageArtistCategories from "./Pages/Audio/Artist_Management/ManageArtistCategories";
import AddManageArtistCategories from "./Pages/Audio/Artist_Management/AddManageArtistCategories";
import AllArtist from "./Pages/Audio/Artist_Management/AllArtist";
import AllPublisher from "./Pages/Audio/Artist_Management/AllPublisher";
import AddPublisher from "./Pages/Audio/Artist_Management/AddPublisher";
import AllPerformer from "./Pages/Audio/Artist_Management/AllPerformer";
import AddPerformer from "./Pages/Audio/Artist_Management/AddPerformer";
import DeviceCropRuleList from "./Pages/DeviceCropRules/DeviceCropRuleList";
import DeviceCropRuleAddUpdate from "./Pages/DeviceCropRules/DeviceCropRuleAddUpdate";
import AllUser from "./Pages/Account/User/AllUser";
import AddUser from "./Pages/Account/User/AddUser";
import ImportUser from "./Pages/Account/User/ImportUser";
import MultiUserManagement from "./Pages/Account/User/MultiUserManagement";
import Menu from "./Pages/Account/Menu/Menu";
import FooterMenu from "./Pages/Account/Menu/FooterMenu";
import MobileMenu from "./Pages/Account/Menu/MobileMenu";
import TVMenu from "./Pages/Account/Menu/TVMenu";
import SignupMenu from "./Pages/Account/SignupMenu/SignupMenu";
import FileManager from "./Pages/Account/FileManager/FileManager";
import Slider from "./Pages/Language/Slider/Slider";
import VideoLanguage from "./Pages/Language/Manage_Language/VideoLanguage";
import SubtitleLanguage from "./Pages/Language/Manage_Language/SubtitleLanguage";
import EditVideoLanguage from "./Pages/Language/Manage_Language/EditVideoLanguage";
import ManageTranslation from "./Pages/Language/Manage_Language/ManageTranslation";
import ManageTranslationLanguage from "./Pages/Language/Manage_Language/ManageTranslationLanguage";
import EditSubtitleLanguage from "./Pages/Language/Manage_Language/EditSubtitleLanguage";
import Player from "./Pages/Site/Player_UI/Player";
import AllPages from "./Pages/Site/Site_Pages/AllPages";
import AddPages from "./Pages/Site/Site_Pages/AddPages";
// import CreateLandingPages from "./Pages/Site/Site_Pages/CreateLandingPages";
import LandingPages from "./Pages/Site/Site_Pages/LandingPages";
import AddLandingPages from "./Pages/Site/Site_Pages/AddLandingPages";
import SubscriptionPlan from "./Pages/Site/Plans/SubscriptionPlan";
import AddSubscriptionPlan from "./Pages/Site/Plans/AddSubscriptionPlan";
import EditSubscriptionPlan from "./Pages/Site/Plans/EditSubscriptionPlan";
import PurchasePlan from "./Pages/Site/Plans/PurchasePlan";
import FieldsList from "./Pages/CustomFields/FieldsList";
import FieldFormEnhanced from "./Pages/CustomFields/FieldFormEnhanced";
import AssignFields from "./Pages/CustomFields/AssignFields";
import FieldSetsList from "./Pages/CustomFields/FieldSetsList";
import FieldSetForm from "./Pages/CustomFields/FieldSetForm";
import Conditions from "./Pages/CustomFields/Conditions";
import CustomFieldsDashboard from "./Pages/CustomFields/Dashboard";
import PluginsManagement from "./Pages/Plugins/PluginsManagement";
import EditPurchasePlan from "./Pages/Site/Plans/EditPurchasePlan";
import PurchaseSubscription from "./Pages/Site/Plans/PurchaseSubscription";
import LifeTimeSubcription from "./Pages/Site/Plans/LifeTimeSubcription";
import Devices from "./Pages/Site/Plans/Devices";
import TotalRevenue from "./Pages/Site/Payment_Management/TotalRevenue";
import SubcriptionPayment from "./Pages/Site/Payment_Management/SubcriptionPayment";
import ViewSubcription from "./Pages/Site/Payment_Management/ViewSubcription";
import PayperviewPayments from "./Pages/Site/Payment_Management/PayperviewPayments";
import ViewPayperview from "./Pages/Site/Payment_Management/ViewPayperview";
import UsersRevenue from "./Pages/Site/Analytics/UsersRevenue";
import UsersAnalytics from "./Pages/Site/Analytics/UsersAnalytics";
import PurchaseVideoAnalytics from "./Pages/Site/Analytics/PurchaseVideoAnalytics";
import CPPAnalytics from "./Pages/Site/Analytics/CPPAnalytics";
import CPPVideoAnalytics from "./Pages/Site/Analytics/CPPVideoAnalytics";
import CPPRevenue from "./Pages/Site/Analytics/CPPRevenue";
import ViewRegion from "./Pages/Site/Analytics/ViewRegion";
import RevenueRegion from "./Pages/Site/Analytics/RevenueRegion";
import PlayerVideoAnalytics from "./Pages/Site/Analytics/PlayerVideoAnalytics";
import RegionVideoAnalytics from "./Pages/Site/Analytics/RegionVideoAnalytics";
import PlayerUserAnalytics from "./Pages/Site/Analytics/PlayerUserAnalytics";
import CPPLiveVideo from "./Pages/Site/Analytics/CPPLiveVideo";
import LiveStreamAnalytics from "./Pages/Site/Analytics/LiveStreamAnalytics";
import PlayerAnalytics from "./Pages/Site/Analytics/PlayerAnalytics";
import StorefrontSettings from "./Pages/Site/Settings/StorefrontSettings";
import UGCIndex from "./Pages/UGC/UGCIndex";
import UGCPending from "./Pages/UGC/UGCPending";
import HomePageSettings from "./Pages/Site/Settings/HomePageSettings";
import Editorderhome from "./Pages/Site/Settings/Editorderhome";
import Apps from "./Pages/Site/Settings/Apps";
import LinkSettings from "./Pages/Site/Settings/LinkSettings";
import ManageAge from "./Pages/Site/Settings/ManageAge";
import AddManageAge from "./Pages/Site/Settings/AddManageAge";
import EditManageAge from "./Pages/Site/Settings/EditManageAge";
import ThemeSettings from "./Pages/Site/Settings/ThemeSettings";
import EmailSettings from "./Pages/Site/Settings/EmailSettings";
import PaymentSettings from "./Pages/Site/Settings/PaymentSettings";
import Stripe from "./Pages/Site/Settings/PaymentSetting_All/Stripe";
import Paypal from "./Pages/Site/Settings/PaymentSetting_All/Paypal";
import Razorpay from "./Pages/Site/Settings/PaymentSetting_All/Razorpay";
import Payhere from "./Pages/Site/Settings/PaymentSetting_All/Payhere";
import Iyzico from "./Pages/Site/Settings/PaymentSetting_All/Iyzico";
import Cashfree from "./Pages/Site/Settings/PaymentSetting_All/Cashfree";
import CashfreeEasySplit from "./Pages/Site/Settings/PaymentSetting_All/CashfreeEasySplit";
import GooglePay from "./Pages/Site/Settings/PaymentSetting_All/GooglePay";
import ApplePay from "./Pages/Site/Settings/PaymentSetting_All/ApplePay";
import Ideabiz from "./Pages/Site/Settings/PaymentSetting_All/Ideabiz";
import PPVPurchasePlansList from "./Pages/PPVPurchasePlans/PPVPurchasePlansList";
import AddPPVPurchasePlans from "./Pages/PPVPurchasePlans/AddPPVPurchasePlans";
import EmailSettingsTemplate from "./Pages/Site/Settings/EmailSettingsTemplate";
import StorageSettings from "./Pages/Site/Settings/StorageSettings";
import MobileSettings from "./Pages/Site/Settings/MobileSettings";
import EditSplashMobileSettings from "./Pages/Site/Settings/EditSplashMobileSettings";
import EditMobileSettings from "./Pages/Site/Settings/EditMobileSettings";
import SocialLoginSettings from "./Pages/Site/Settings/SocialLoginSettings";
import CurrencySettings from "./Pages/Site/Settings/CurrencySettings";
import RevenueSettings from "./Pages/Site/Settings/RevenueSettings";
import ThumbnailSettings from "./Pages/Site/Settings/ThumbnailSettings";
import ProfileScreen from "./Pages/Site/Settings/ProfileScreen";
import Pesapal from "./Pages/Site/Settings/PaymentSetting_All/Pesapal"
import PlanContentSettings from "./Pages/Site/Settings/PlanContentSettings";


import Theme from "./Pages/Site/Settings/Theme";
import ImageSettings from "./Pages/Site/Settings/ImageSettings";
import PopupSettings from "./Pages/Site/Settings/PopupSettings";
import CommentSetting from "./Pages/Site/Settings/CommentSetting";
import AdvertiserList from "./Pages/Ads_Categories/Manage_Advertiser/AdvertiserList";
import EditAdvertiser from "./Pages/Ads_Categories/Manage_Advertiser/EditAdvertiser";
import EditAdsList from "./Pages/Ads_Categories/Ads_List/EditAdsList";
import AdsCategories from "./Pages/Ads_Categories/Ads_Categories/AdsCategories";
import EditAdsCategories from "./Pages/Ads_Categories/Ads_Categories/EditAdsCategories";
import AdsList from "./Pages/Ads_Categories/Ads_List/AdsList";
import AdsPlan from "./Pages/Ads_Categories/Ads_Plan/AdsPlan";
import AddAdsPlan from "./Pages/Ads_Categories/Ads_Plan/AddAdsPlan";
import EditAdsPlan from "./Pages/Ads_Categories/Ads_Plan/EditAdsPlan";
import AdsRevenue from "./Pages/Ads_Categories/Ads_Revenue/AdsRevenue";
import AdsMonetization from "./Pages/Ads_Categories/Ads_Monetization/AdsMonetization";
import CalenderEvent from "./Pages/Ads_Categories/Calender_Event/CalenderEvent";
import AdsCampaigns from "./Pages/Ads_Categories/Ads_Campaigns/AdsCampaigns";
import AdsTimeSlot from "./Pages/Ads_Categories/Ads_Time_Slot/AdsTimeSlot";
import ManageGeoFencing from "./Pages/Geo_Fencing/Manage_Geo_Fencing/ManageGeoFencing";
import ManageCountry from "./Pages/Geo_Fencing/Manage_Country/ManageCountry";
import CacheManagement from "./Pages/Configuration/Cache_Management/CacheManagement";
import Debug from "./Pages/Configuration/Manage_Geo_Fencing/Debug";
import ContactRequest from "./Pages/ContactUs/Cache Management/ContactRequest";
import PreviewContact from "./Pages/ContactUs/Cache Management/PreviewContact";
import SeeLogActivity from "./Pages/LogActivity/Cache_Management/SeeLogActivity";
import EditAddNewLiveStream from "./Pages/Live Stream/Management_Live_Stream/EditAddNewLiveStream";
import UpdateCurrencySettings from "./Pages/Site/Settings/UpdateCurrencySettings";
import ViewTemplate from "./Pages/Site/Settings/ViewTemplate";

import Rtmpurl from "./Pages/Site/Settings/Site_Setting/Rtmpurl";
import Site_Setting from "./Pages/Site/Settings/Site_Setting/Site_Setting";
import Ppv_Setting from "./Pages/Site/Settings/Site_Setting/Ppv_Setting";
import Video_Setting from "./Pages/Site/Settings/Site_Setting/Video_Setting";
import Registration_Setting from "./Pages/Site/Settings/Site_Setting/Registration_Setting";
import Email_Setting from "./Pages/Site/Settings/Site_Setting/Email_Setting";
import Social_Network_Setting from "./Pages/Site/Settings/Site_Setting/Social_Network_Setting";
import Series_Setting from "./Pages/Site/Settings/Site_Setting/Series_Setting";
import Transcoding_Setting from "./Pages/Site/Settings/Site_Setting/Transcoding_Setting";
import Loginpage_Setting from "./Pages/Site/Settings/Site_Setting/Loginpage_Setting";
import Advertisement_Setting from "./Pages/Site/Settings/Site_Setting/Advertisement_Setting";
import App_Setting from "./Pages/Site/Settings/Site_Setting/App_Setting";
import Script_Setting from "./Pages/Site/Settings/Site_Setting/Script_Setting";
import Default_Image_Setting from "./Pages/Site/Settings/Site_Setting/Default_Image_Setting";
import Payouts_Setting from "./Pages/Site/Settings/Site_Setting/Payouts_Setting";
import Recaptcha_Setting from "./Pages/Site/Settings/Site_Setting/Recaptcha_Setting";
import Timezone_Setting from "./Pages/Site/Settings/Site_Setting/Timezone_Setting";
import Manage_Geo_Fencing from "./Pages/Site/Settings/Site_Setting/Manage_Geo_Fencing";
import Site_met_settings from "./Pages/Site/Settings/Site_met_settings";
import Tv_Settings from "./Pages/Site/Settings/Tv_Settings";
import Update_Tv_Settings from "./Pages/Site/Settings/Update_Tv_Settings";

import AllVideos from "./Channel_Partner/VideoManagement/AllVideos";
import AddNewVideo from "./Channel_Partner/VideoManagement/AddNewVideo";
import ManageVideoCategories from "./Channel_Partner/VideoManagement/ManageVideoCategories";
// import Payouts from "./Channel_Partner/Analytics/Payouts";
import VideoAnalytics from "./Channel_Partner/Analytics/VideoAnalytics";
import VideoViewRegion from "./Channel_Partner/Analytics/VideoViewRegion";
import MyChannelSettings from "./Channel_Partner/SettingManage/MyChannelSettings";
import AllLiveVideo from "./Channel_Partner/ManageLiveVideo/AllLiveVideo";
import AddNewLiveVideo from "./Channel_Partner/ManageLiveVideo/AddNewLiveVideo";
import ManageLiveVideoCategories from "./Channel_Partner/ManageLiveVideo/ManageLiveVideoCategories";
import AddManageCategories from "./Channel_Partner/ManageLiveVideo/AddManageCategories";
import ManageLiveEvent from "./Channel_Partner/ManageLiveVideo/ManageLiveEvent";
import AddManageLiveEvent from "./Channel_Partner/ManageLiveVideo/AddManageLiveEvent";
import AudioLists from "./Channel_Partner/AudioManagement/AudioLists";
import ManageAudioCategories from "./Channel_Partner/AudioManagement/ManageAudioCategories";
import AddCategory from "./Channel_Partner/AudioManagement/AddCategory";
import ManageAlbums from "./Channel_Partner/AudioManagement/ManageAlbums";
import Addalbums from "./Channel_Partner/AudioManagement/Addalbums";
import SeriesLists from "./Channel_Partner/Series&Episode/SeriesLists";
import AddNewSeries from "./Channel_Partner/Series&Episode/AddNewSeries";
import AddManageVideoCategory from "./Channel_Partner/VideoManagement/AddManageVideoCategory";
import AddnewAudios from "./Channel_Partner/AudioManagement/AddnewAudios";
// import ChannelPage from "./Channel_Partner/ChannelPage";
import DashBoards from "./Channel_Partner/DashBoard/DashBoards";
import All_Videos from "./Content_Partner/VideoManagement/All_Videos";
import Add_NewVideos from "./Content_Partner/VideoManagement/Add_NewVideos";
import Manage_VideoCategories from "./Content_Partner/VideoManagement/Manage_VideoCategories";
import AddManage_VideoCategories from "./Content_Partner/VideoManagement/AddManage_VideoCategories";
import Audio_Lists from "./Content_Partner/AudioManagement/Audio_Lists";
import Add_NewAudios from "./Content_Partner/AudioManagement/Add_NewAudios";
import Manage_AudioCategories from "./Content_Partner/AudioManagement/Manage_AudioCategories";
import Manage_Albums from "./Content_Partner/AudioManagement/Manage_Albums";
import Add_category from "./Content_Partner/AudioManagement/Add_category";
import Add_Albums from "./Content_Partner/AudioManagement/Add_Albums";
import All_LiveVideo from "./Content_Partner/ManageLiveVideo/All_LiveVideo";
import Add_NewLiveVideo from "./Content_Partner/ManageLiveVideo/Add_NewLiveVideo";
import Manage_LiveCategory from "./Content_Partner/ManageLiveVideo/Manage_LiveCategory";
import Add_manageLiveCategory from "./Content_Partner/ManageLiveVideo/Add_manageLiveCategory";
import Manage_LiveEvent from "./Content_Partner/ManageLiveVideo/Manage_LiveEvent";
import Add_ManageLiveEvent from "./Content_Partner/ManageLiveVideo/Add_ManageLiveEvent";
import Video_Analytics from "./Content_Partner/Analytics/Video_Analytics";
import Video_ViewRegion from "./Content_Partner/Analytics/Video_ViewRegion";
import Video_Payout from "./Content_Partner/Analytics/Video_Payout";
import Live_StreamPayout from "./Content_Partner/Analytics/Live_StreamPayout";
import All_pages from "./Content_Partner/Pages/All_pages";
import Add_pages from "./Content_Partner/Pages/Add_pages";
import Dash_Board from "./Content_Partner/Dash_Board/Dash_Board";
import About_MyProfile from "./Content_Partner/Profile/About_MyProfile";

import MobileDeepLinkingSettings from "./Pages/Site/Settings/MobileDeepLinkingSettings";
import Error404 from "./Error404/error404";
import Maintances from "./Error404/Maintances";
import Terms_and_condition from "./layout/Footer/Terms_and_condition";
import Privacy_policy from "./layout/Footer/Privacy_policy";
import Update_Site_met_settings from "./Pages/Site/Settings/Update_Site_met_settings";
import Video_Playlist from "./Pages/Video/Video_Management/Video_Playlist";
import AllVideo_Playlist from "./Pages/Video/Video_Management/AllVideo_Playlist";
import AllAudio_Playlist from "./Pages/Audio/Audio_Management/AllAudio_Playlist";
import Audio_Playlist from "./Pages/Audio/Audio_Management/Audio_Playlist";
import EditManageCalendarschedule from "./Pages/Video/Video_Management/EditManageCalendarschedule";
import Dsp_Settings from "./Pages/Site/Settings/Dsp_Settings";
import LoaderPage from "./components/LoaderPage";
import Search_Setting from "./Pages/Site/Settings/Site_Setting/Search_Setting";
import Library_Setting from "./Pages/Site/Settings/Site_Setting/Library_Settings";
import MusicSettings from "./Pages/Site/Music/MusicSettings";
import AudioSettings from "./Pages/Site/Settings/AudioSettings";
import AudioOrderEdit from "./Pages/Site/Settings/AudioOrderEdit";
import Main_labels from "./Pages/Site/Settings/Label_Settings/Main_labels";
import Labelsstorelabels from "./Pages/Site/Settings/Label_Settings/Labelsstorelabels";
import Label_source from "./Pages/Site/Settings/Label_Settings/Label_source_list";
import EditTranslationLanguage from "./Pages/Language/Manage_Language/EditTranslationLanguage";
import PrivateRoute from "./components/CommonComponents/PrivateRoute";
import ManageTranslationVer from "./Pages/Language/Manage_Language/ManageTranslationVer";

import FAQ from "./Pages/Faq/FAQ";
import Faq_category from "./Pages/Faq/Faq_category";
import Add_Faq_category from "./Pages/Faq/Add_Faq_category";
import EmaiLogs from "./Pages/Site/Settings/EmaiLogs";
import AdsUpload from "./Pages/Ads_Categories/Ads_Upload/AdsUpload";
import MovieSettings from "./Pages/Site/Settings/MovieSettings";
import ShowSettings from "./Pages/Site/Settings/ShowSettings";
import LiveSettings from "./Pages/Site/Settings/LiveSettings";
import MovieOrderEdit from "./Pages/Site/Settings/MovieOrderEdit";
import ShowOrderEdit from "./Pages/Site/Settings/ShowOrderEdit";
import SubscriberAnalytics from "./Pages/Site/Analytics/SubscriberAnalytics";
import PPVAnalytics from "./Pages/Site/Analytics/PPVAnalytics";
import ChannelPartnerSignupMenu from "./Pages/Account/SignupMenu/ChannelPartnerSignupMenu";
import ContentPartnerSignupMenu from "./Pages/Account/SignupMenu/ContentPartnerSignupMenu";

import Tvplayouts from "./Pages/Tv_Playout/Tvplayouts";
import EditTvplayouts from "./Pages/Tv_Playout/EditTvplayouts";
import PlayoutLogs from "./Pages/Tv_Playout/PlayoutLogs";
import PartnerMonetizationSettings from "./Pages/Partner/Settings/PartnerMonetizationSettings";
import OTPCredentialsSettings from "./Pages/OTP/OTPCredentialsSettings";
import LiveCategoryAddEdit from "./Pages/Live Stream/Management_Live_Stream/LiveCategoryAddEdit";
import PartnerIndex from "./Pages/Site/Partner/PartnerIndex";
import PartnerCreate from "./Pages/Site/Partner/PartnerCreate";
import PartnerEdit from "./Pages/Site/Partner/PartnerEdit";
import PartnerPayout from "./Pages/Site/Partner/PartnerPayout";
import PartnerApproval from "./Pages/Site/Partner/PartnerForApproval";
import PartnerSignupMenu from "./Pages/Account/SignupMenu/PartnerSignupMenu";
import PartnerSignup from "./components/Signup/PartnerSignup";
import RoleIndex from "./Pages/Site/Roles/RoleIndex";
import RoleCreate from "./Pages/Site/Roles/RoleCreate";
import PartnerSignin from "./components/Signin/PartnerSignin";
import LandingPreview from "./Pages/Site/Site_Pages/LandingPreview";
import PartnerCommission from "./Pages/Site/Partner/PartnerCommission";
import AssignPartnerToContent from "./Pages/Site/Partner/AssignPartnerToContent";
import MultiFileUpload from "./Utils/MultiFileUpload";
import AllLibrary from "./Pages/Library/AllLibrary";
import LibraryManage from "./Pages/Library/LibraryManage";
import UnifiedVideoPlayer from "./Pages/Player/UnifiedVideoPlayer";
import Monetization_Details from "./Pages/Site/Partner/Monetization_Details";
import PartnerPayout_Analytics from "./Pages/Site/Partner/PartnerPayout_Analytics";
import PartnerPayout_History from "./Pages/Site/Partner/PartnerPayment_History";
import RedisSetting from "./Pages/Site/Settings/Site_Setting/RedisSetting";
import ArtistAddUpdate from "./Pages/Audio/Artist_Management/ArtistAddUpdate";
import OrientationAddUpdate from "./Pages/Orientation/OrientationAddUpdate";
import OrientationList from "./Pages/Orientation/OrientationList";
import FooterAddUpdate from "./Pages/Account/Menu/FooterAddUpdate";
import MenuAddUpdate from "./Pages/Account/Menu/MenuAddUpdate";
import MobileMenuAddUpdate from "./Pages/Account/Menu/MobileMenuAddUpdate";
import TVMenuAddUpdate from "./Pages/Account/Menu/TVMenuAddUpdate";
import TVSidebarMenuAddUpdate from "./Pages/Account/Menu/TVSidebarMenuAddUpdate";
import VideoAddUpdate from "./Pages/Video/Video_Management/VideoAddUpdate";
import SliderAddUpdate from "./Pages/Language/Slider/SliderAddUpdate";
import LanguageAddUpdate from "./Pages/Language/Manage_Language/LanguageAddUpdate";
import RegionList from "./Pages/Region/Manage_Region/RegionList";
import RegionAddUpdate from "./Pages/Region/Manage_Region/RegionAddUpdate";
import AudioCategoryAddUpdate from "./Pages/Audio/Audio_Management/AudioCategoryAddUpdate";
import AudioAlbumAddUpdate from "./Pages/Audio/Audio_Management/AudioAlbumAddUpdate";
import ImportExport from "./Pages/Import_Export/ImportExport";
import TranscodingFailed from "./Pages/Site/Settings/Site_Setting/TranscodingFailed";
import SeriesAddUpdate from "./Pages/Video/Series&Episode/SeriesAddUpdate";
import FileUploader from "./Pages/FileUploader";
import ManageSeason from "./Pages/Video/Series&Episode/ManageSeason";
import EpisodeAddUpate from "./Pages/Video/Series&Episode/EpisodeAddUpate";
import SeriesGenreAddUpdate from "./Pages/Video/Series&Episode/SeriesGenreAddUpdate";
import Playoutsetting from "./Pages/Site/Settings/Playoutsetting";
import ProductTypeSetting from "./Pages/Site/Settings/ProductTypeSetting";
import PaymentGatewaysSettings from "./Pages/Site/Settings/PaymentGatewaysSettings";
import LiveOrderEdit from "./Pages/Site/Settings/LiveOrderEdit";
import TranscodingJobs from "./Pages/Site/Settings/Site_Setting/TranscodingJobs";
import AllPartners from "./Pages/Site/Partner/AllPartners"
import EditPartner from './Pages/Site/Partner/EditPartner'
import AddPartner from './Pages/Site/Partner/AddPartner'
import ApprovePartner from './Pages/Site/Partner/ApprovePartner'
import PartnerProfile from './Pages/Site/Partner/PartnerProfile'
import DeploymentSuccess from "./Pages/Site/Deployment/DeploymentSuccess";
import AddEditRadioStation from '../src/Pages/Live Stream/Radio_station/AddEditRadioStation'
import ManageRadioStationCategories from '../src/Pages/Live Stream/Radio_station/ManageRadioStationCategories'
import RadioStationCategoryAddEdit from '../src/Pages/Live Stream/Radio_station/RadioStationCategoryAddEdit'
import AllRadioStation from '../src/Pages/Live Stream/Radio_station/AllRadioStation'
import EPGSettings from "./Pages/Site/Settings/FeatureSettings";
import PartnerSettings from "./Pages/Site/Settings/PartnerSettings";
import Partner_analytis_payout from "./Pages/Partner_payout_all/Partner_analytis_payout";
import Partner_Content_List from "./Pages/Partner_payout_all/Partner_Content_List";
import Partner_Index_List from "./Pages/Partner_payout_all/Partner_Index_List";
import AllPartnercontent from "./Pages/Site/Partner/AllPartnercontent";
import PartnerContentOverview from "./Pages/Site/Partner/PartnerContentOverview";
import PartnerAnalytics from "./Pages/Site/Partner/PartnerAnalytics";
import Ideatobill from "./Pages/Site/Plans/Ideatobill";
import EditIdeatobill from "./Pages/Site/Plans/EditIdeatobill";
import PushNotificationList from "./Pages/PushNotification/PushNotificationList";
import AddPushNotification from "./Pages/PushNotification/AddPushNotification";
import GoogleProductPPVManager from "./Pages/Site/Plans/GoogleProductPPVManager";
import EditGoogleProductPPV from "./Pages/Site/Plans/EditGoogleProductPPV";
import Signup_avatars from "./Pages/Site/Settings/Site_Setting/Signup_avatars";
import PushNotification from "./Pages/Site/Settings/Site_Setting/PushNotification";
import Slider_Setting from "./Pages/Site/Settings/Site_Setting/Slider_Setting";
import PlayoutTourProvider from "./components/Tour/PlayoutTourProvider";
import DonationDetails from "./Pages/DonationManagement/DonationDetails";
import DonationTransactions from "./Pages/DonationManagement/DonationTransactions";
import ContentClassification from "./Pages/Site/Settings/Site_Setting/ContentClassification";
import SidebarMenu from "./Pages/Account/Menu/SidebarMenu";
import SidebarMenuAddUpdate from "./Pages/Account/Menu/SidebarMenuAddUpdate";
import SSAIAdsManagement from "./Pages/Ads_Categories/SSAI_Ads/SSAIAdsManagement";
import LivekitConfiguration from "./Pages/Site/Settings/Site_Setting/LivekitConfiguration";

function AllRoutes(props) {


  const [apiresponsealert, setApiresponsealert] = useState();
  const [showalert, setShowalert] = useState();
  const userData = localStorage.getItem("access_token");
  const userRole = localStorage.getItem("role");

  const [productType, setProductType] = useState('full_package');
  const access_token = localStorage.getItem("access_token");
  const role = localStorage.getItem("role");
  const headers = {
    "Content-Type": "application/json", Authorization: "Bearer " + access_token,
    Accept: "application/json", "Access-Control-Allow-Origin": "*",
  };

  // Determine which dashboard to show based on user role
  const getDashboardComponent = () => {
    // Check if user is a partner (role 4)
    const isPartner = userRole === "4";

    if (isPartner) {
      // console.log('Loading Partner Dashboard for role:', userRole);
      return <Dashboard_Partner setApiresponsealert={setApiresponsealert} setShowalert={setShowalert} />;
    } else {
      // console.log('Loading Admin Dashboard for role:', userRole);
      return <Dashboard setApiresponsealert={setApiresponsealert} setShowalert={setShowalert} />;
    }
  };

  // (async () => {
  //   try {
  //     const resp = await axios.get(`${process.env.REACT_APP_Baseurl}/admin/main-settings/get`, { headers, params: { fields: 'productType' } });
  //     setProductType(resp?.data?.data?.productType || 'full_package');
  //   } catch (e) {
  //     setProductType('full_package');
  //   }
  // })();

  return (
    <>
      <Suspense fallback={<LoaderPage />}>
        <Routes>
          <Route path="/nexs-player/:id/:slug" element={<UnifiedVideoPlayer />} ></Route>
          <Route path="/nexs-player/playout/:slug" element={<UnifiedVideoPlayer />} ></Route>
          <Route path="/:params" element={<AutoLogin />} />
          <Route path="/login" element={<Signin setApiresponsealert={setApiresponsealert} setShowalert={setShowalert} />} ></Route>
          <Route path="/partner-signup" element={<PartnerSignup />} ></Route>
          <Route path="/partner" element={<PartnerSignin />} ></Route>
          {/* <Route path="/signup" element={<Signup setApiresponsealert={setApiresponsealert} setShowalert={setShowalert} />} ></Route> */}
          <Route path="/maintances" element={<Maintances setApiresponsealert={setApiresponsealert} setShowalert={setShowalert} ></Maintances>} ></Route>
          <Route path="/landing-page-preview/:id" element={<PrivateRoute><LandingPreview /> </PrivateRoute>}  ></Route>
          {/* Public/Shareable unified player route (no admin layout for full page experience) */}

          <Route path="/" element={userData ? (<PlayoutTourProvider><Layout apiresponsealert={apiresponsealert} showalert={showalert} setApiresponsealert={setApiresponsealert} setShowalert={setShowalert} /></PlayoutTourProvider>) : <Navigate to="/login" />}>
            <Route index element={<PrivateRoute>{getDashboardComponent()}</PrivateRoute>} />
            <Route path="/partner" element={<PrivateRoute><Dashboard_Partner setApiresponsealert={setApiresponsealert} setShowalert={setShowalert} ></Dashboard_Partner></PrivateRoute>} />
            {/* Video route start */}
            <Route path="/video-lists" element={<PrivateRoute><Allvideo></Allvideo></PrivateRoute>} ></Route>
            <Route path="/edit-video/:id" element={<PrivateRoute><VideoAddUpdate /></PrivateRoute>} ></Route>
            <Route path="/add-video" element={<PrivateRoute><VideoAddUpdate /></PrivateRoute>} ></Route>
            <Route path="/edit-new-video/:id" element={<PrivateRoute><VideoAddUpdate /></PrivateRoute>} ></Route>
            <Route path="/library" element={<PrivateRoute><AllLibrary /></PrivateRoute>} ></Route>
            <Route path="/add-library" element={<PrivateRoute><LibraryManage /></PrivateRoute>} ></Route>
            <Route path="/library-preview/:id" element={<PrivateRoute><LibraryManage /></PrivateRoute>} ></Route>

            {/* Video route end */}
            {/* Series route start */}
            <Route path="/series-list" element={<PrivateRoute><SeriesList setApiresponsealert={setApiresponsealert} setShowalert={setShowalert}></SeriesList></PrivateRoute>} ></Route>
            <Route path="/add-series" element={<PrivateRoute><SeriesAddUpdate /> </PrivateRoute>} ></Route>
            <Route path="/edit-series/:id" element={<PrivateRoute><SeriesAddUpdate /></PrivateRoute>} ></Route>
            <Route path="/manage-episode" element={<PrivateRoute><ManageSeason /></PrivateRoute>}></Route>
            <Route path="/edit-episode" element={<PrivateRoute><EpisodeAddUpate /></PrivateRoute>}></Route>
            <Route path="/series-category" element={<PrivateRoute><ManageSeries /></PrivateRoute>}  ></Route>
            <Route path="/add-series-category" element={<PrivateRoute><SeriesGenreAddUpdate /></PrivateRoute>}  ></Route>
            <Route path="/edit-series-category/:id" element={<PrivateRoute><SeriesGenreAddUpdate /></PrivateRoute>}  ></Route>

            {/* Series route end */}
            <Route path="/file-upload" element={<PrivateRoute><FileUploader ></FileUploader></PrivateRoute>} ></Route>
            <Route path="/test-data" element={<MultiFileUpload />} ></Route>

            {/* Setting route start */}
            <Route path="/theme_settings" element={<PrivateRoute><ThemeSettings /></PrivateRoute>} />
            <Route path="/plan-content-settings" element={<PrivateRoute><PlanContentSettings /></PrivateRoute>} />
            <Route path="/audio-settings" element={<PrivateRoute><AudioSettings /></PrivateRoute>} />
            <Route path="/edit-audio-order/:id" element={<PrivateRoute><AudioOrderEdit /></PrivateRoute>} />
            <Route path="/movie-settings" element={<PrivateRoute><MovieSettings /></PrivateRoute>} />
            <Route path="/edit-movie-order/:id" element={<PrivateRoute><MovieOrderEdit /></PrivateRoute>} />
            <Route path="/show-settings" element={<PrivateRoute><ShowSettings /></PrivateRoute>} />
            <Route path="/edit-show-order/:id" element={<PrivateRoute><ShowOrderEdit /></PrivateRoute>} />
            <Route path="/live-settings" element={<PrivateRoute><LiveSettings /></PrivateRoute>} />
            <Route path="/edit-live-order/:id" element={<PrivateRoute><LiveOrderEdit /></PrivateRoute>} />
            {/* Setting route end */}

            {/* Audio route start */}
            <Route path="/audio-lists" element={<PrivateRoute><AudioList /></PrivateRoute>} />
            <Route path="/add-audio" element={<PrivateRoute> <Addnewaudio />  </PrivateRoute>} />
            <Route path="/edit-audio/:id" element={<PrivateRoute><Editnewaudio /></PrivateRoute>} />
            <Route path="/edit-new-audio/:id" element={<PrivateRoute><Editnewaudio /></PrivateRoute>} />
            <Route path="/details-entry/:id" element={<PrivateRoute><Editnewaudio /></PrivateRoute>} />
            <Route path="/add-song-writer-percentage-holding/:id" element={<PrivateRoute><StoreSong_Writer /></PrivateRoute>} />
            <Route path="/update-song-writer-percentage-holding/:id" element={<PrivateRoute><Updatesong_Writer /></PrivateRoute>} />
            <Route path="/audio-categories" element={<PrivateRoute><Manageaudiocategories /></PrivateRoute>} />
            <Route path="/add-audio-categories" element={<PrivateRoute><AudioCategoryAddUpdate /></PrivateRoute>} />
            <Route path="/edit-audio-categories/:id" element={<PrivateRoute><AudioCategoryAddUpdate /></PrivateRoute>} />

            <Route path="/device-crop-rules" element={<PrivateRoute><DeviceCropRuleList /></PrivateRoute>} />
            <Route path="/add-device-crop-rule" element={<PrivateRoute><DeviceCropRuleAddUpdate /></PrivateRoute>} />
            <Route path="/edit-device-crop-rule/:id" element={<PrivateRoute><DeviceCropRuleAddUpdate /></PrivateRoute>} />

            {/* Album start */}
            <Route path="/manage-albums" element={<PrivateRoute><Managealbum /></PrivateRoute>} ></Route>
            <Route path="/add-album" element={<PrivateRoute><AudioAlbumAddUpdate /></PrivateRoute>} ></Route>
            <Route path="/edit-album/:id" element={<PrivateRoute><AudioAlbumAddUpdate /></PrivateRoute>} ></Route>
            {/* Ablum end */}

            {/* Artist route start */}
            <Route path="/all-artist" element={<PrivateRoute><AllArtist /></PrivateRoute>} />
            <Route path="/add-artist" element={<PrivateRoute><ArtistAddUpdate /></PrivateRoute>} />
            <Route path="/edit-artist/:id" element={<PrivateRoute><ArtistAddUpdate /></PrivateRoute>} />
            <Route path="/artist-type" element={<PrivateRoute><ManageArtistCategories /></PrivateRoute>} />
            <Route path="/add-artist-type" element={<PrivateRoute><AddManageArtistCategories /></PrivateRoute>} />
            <Route path="/edit-artist-type/:id" element={<PrivateRoute><AddManageArtistCategories /></PrivateRoute>} />

            <Route path="/artists-musician" element={<PrivateRoute><AllPerformer /></PrivateRoute>} />
            <Route path="/add-artist-musician" element={<PrivateRoute><AddPerformer /></PrivateRoute>} />
            <Route path="/edit-artist-musician/:id" element={<PrivateRoute><AddPerformer /></PrivateRoute>} />

            <Route path="/artists-songwriter" element={<PrivateRoute><AllPublisher /></PrivateRoute>} />
            <Route path="/add-artist-songwriter" element={<PrivateRoute><AddPublisher /></PrivateRoute>} />
            <Route path="/edit-artist-songwriter/:id" element={<PrivateRoute><AddPublisher /></PrivateRoute>} />

            <Route path="/orientation-list" element={<PrivateRoute><OrientationList /></PrivateRoute>} />
            <Route path="/add-orientation" element={<PrivateRoute><OrientationAddUpdate /></PrivateRoute>} />
            <Route path="/edit-orientation/:id" element={<PrivateRoute><OrientationAddUpdate /></PrivateRoute>} />

            {/* Artist route end */}

            {/* <Route path="/admin/channel" element={<PrivateRoute><ChannelPage></ChannelPage>}></Route> */}
            <Route path="/admin/channel/dashboard" element={<PrivateRoute><DashBoards setApiresponsealert={setApiresponsealert} setShowalert={setShowalert}  ></DashBoards></PrivateRoute>} ></Route>
            <Route path="/admin/channel/allvideos" element={<PrivateRoute><AllVideos setApiresponsealert={setApiresponsealert} setShowalert={setShowalert}></AllVideos></PrivateRoute>}></Route>

            {/* 
             //#region Ads Management
            */}
            <Route path="/ads-upload" element={<PrivateRoute> <AdsUpload /></PrivateRoute>} />
            <Route path="/ads-edit/:id" element={<PrivateRoute> <AdsUpload /></PrivateRoute>} />
            <Route path="/ads-list" element={<PrivateRoute> <AdsList /></PrivateRoute>} ></Route>
            <Route path="/ssai-settings" element={<PrivateRoute> <SSAIAdsManagement /></PrivateRoute>} ></Route>



            {/* User Start */}
            <Route path="/users" element={<PrivateRoute><AllUser /></PrivateRoute>} ></Route>
            <Route path="/add-users" element={<PrivateRoute><AddUser /> </PrivateRoute>}></Route>
            <Route path="/edit-users/:id" element={<PrivateRoute> <AddUser /></PrivateRoute>} ></Route>
            <Route path="/import-users-view" element={<PrivateRoute>  <ImportUser /> </PrivateRoute>}   ></Route>
            {/* User End */}


            {/* Analytics start */}
            <Route path="/analytics/subscriber" element={<PrivateRoute><SubscriberAnalytics /></PrivateRoute>} ></Route>
            <Route path="/analytics/ppv" element={<PrivateRoute><PPVAnalytics /></PrivateRoute>} ></Route>
            {/* Analytics end */}


            {/* Video Category start */}

            <Route path="/video-categories" element={<PrivateRoute> <Managevideocategories /> </PrivateRoute>} ></Route>
            <Route path="/add-categories" element={<PrivateRoute> <AddManagevideocategories /> </PrivateRoute>} ></Route>
            <Route path="/edit-categories/:id" element={<PrivateRoute>  <AddManagevideocategories /> </PrivateRoute>} ></Route>

            {/* Video Playlist start */}
            <Route path="/add-playlist" element={<PrivateRoute> <Video_Playlist /> </PrivateRoute>} ></Route>
            <Route path="/edit-playlist/:id" element={<PrivateRoute><Video_Playlist /></PrivateRoute>}></Route>
            <Route path="/allplaylist" element={<PrivateRoute> <AllVideo_Playlist /> </PrivateRoute>} ></Route>

            {/* Audio Playlist start */}
            <Route path="/audio-playlist" element={<PrivateRoute> <AllAudio_Playlist /> </PrivateRoute>} ></Route>
            <Route path="/add-audio-playlist" element={<PrivateRoute> <Audio_Playlist /> </PrivateRoute>} ></Route>
            <Route path="/edit-audio-playlist/:id" element={<PrivateRoute> <Audio_Playlist /> </PrivateRoute>} ></Route>


            {/* PARTNER PAYOUT LISTS START */}
            <Route path="/partner-monitazation-index" element={<PrivateRoute> <Partner_Index_List /> </PrivateRoute>} ></Route>
            <Route path="/partner-monetization-content" element={<PrivateRoute> <Partner_Content_List /> </PrivateRoute>} ></Route>
            <Route path="/partner-monitazation-analytics" element={<PrivateRoute> <Partner_analytis_payout /> </PrivateRoute>} ></Route>
            {/* PARTNER PAYOUT LISTS end */}

            {/* Partner Settings start */}
            <Route path="/partner-monetization-settings" element={<PrivateRoute> <PartnerMonetizationSettings /></PrivateRoute>} ></Route>
            <Route path="/otp-credentials" element={<PrivateRoute> <OTPCredentialsSettings /></PrivateRoute>} ></Route>
            <Route path="/all-partner" element={<PrivateRoute> <AllPartners /> </PrivateRoute>}></Route>
            <Route path="/add-partner" element={<PrivateRoute> < AddPartner /> </PrivateRoute>}></Route>
            <Route path="/edit-partner/:id" element={<PrivateRoute><EditPartner /> </PrivateRoute>}></Route>
            <Route path="/approve-partner" element={<PrivateRoute><ApprovePartner /> </PrivateRoute>}></Route>
            <Route path="/partner-analytics" element={<PrivateRoute><PartnerAnalytics /> </PrivateRoute>}></Route>
            <Route path="/partner-profile" element={<PrivateRoute><PartnerProfile /></PrivateRoute>}></Route>
            <Route path="/partner/payouts" element={<PrivateRoute><PartnerPayout /> </PrivateRoute>}></Route>
            <Route path="/partner/commission" element={<PrivateRoute><PartnerCommission /> </PrivateRoute>} ></Route>
            <Route path="/partner/assign" element={<PrivateRoute><AssignPartnerToContent /> </PrivateRoute>} ></Route>
            <Route path="/monetization-detail/:id" element={<PrivateRoute><Monetization_Details /> </PrivateRoute>} ></Route>
            <Route path="/partner/payout/analytics" element={<PrivateRoute><PartnerPayout_Analytics /> </PrivateRoute>} ></Route>
            <Route path="/partner/payment/history" element={<PrivateRoute><PartnerPayout_History /> </PrivateRoute>} ></Route>

            <Route path="/partner-index" element={<PrivateRoute> <PartnerIndex /> </PrivateRoute>}></Route>
            <Route path="/partner-edit/:id" element={<PrivateRoute> <PartnerEdit /> </PrivateRoute>}></Route>
            <Route path="/partner-create" element={<PrivateRoute> <PartnerCreate /> </PrivateRoute>}></Route>
            <Route path="/partner-approval" element={<PrivateRoute> <PartnerApproval /> </PrivateRoute>}></Route>

            <Route path="/partner-content" element={<PrivateRoute><AllPartnercontent /></PrivateRoute>} ></Route>
            <Route path="/partner-content-overview" element={<PrivateRoute><PartnerContentOverview /></PrivateRoute>} ></Route>

            {/* Partner Settings end */}

            {/* Roles */}
            <Route path="/role-index" element={<PrivateRoute><RoleIndex /> </PrivateRoute>}></Route>
            <Route path="/role-create" element={<PrivateRoute><RoleCreate /> </PrivateRoute>}></Route>
            <Route path="/role-edit/:id" element={<PrivateRoute><RoleCreate /> </PrivateRoute>}></Route>
            {/* Roles */}

            {/* Import/Export Management */}
            <Route path="/import-export" element={<PrivateRoute><ImportExport /> </PrivateRoute>} ></Route>

            {/* Livestream start */}
            <Route path="/livestream" element={<PrivateRoute>   <AllLiveStream /> </PrivateRoute>} ></Route>
            <Route path="/add-livestream" element={<PrivateRoute> <AddNewLiveStream /> </PrivateRoute>} ></Route>
            <Route path="/edit-livestream/:id" element={<PrivateRoute><AddNewLiveStream /> </PrivateRoute>}></Route>
            {(productType !== 'livestream') &&
              <Route path="/livestream-categories" element={<PrivateRoute><ManageLiveCategories /></PrivateRoute>} ></Route>
            }
            <Route path="/livestream-add-categories" element={<PrivateRoute><LiveCategoryAddEdit /> </PrivateRoute>} ></Route>
            <Route path="/livestream-edit-categories/:id" element={<PrivateRoute><LiveCategoryAddEdit /> </PrivateRoute>}  ></Route>
            {/* Livestream end */}

            {/* Radio Station start */}
            <Route path="/radio-station" element={<PrivateRoute>   <AllRadioStation /> </PrivateRoute>} ></Route>
            <Route path="/add-radio-station" element={<PrivateRoute> <AddEditRadioStation /> </PrivateRoute>} ></Route>
            <Route path="/edit-radio-station/:id" element={<PrivateRoute><AddEditRadioStation /> </PrivateRoute>}></Route>

            <Route path="/radio-station-categories" element={<PrivateRoute><ManageRadioStationCategories /></PrivateRoute>}></Route>
            <Route path="/radio-station-add-categories" element={<PrivateRoute><RadioStationCategoryAddEdit /></PrivateRoute>}></Route>
            <Route path="/radio-station-edit-categories/:id" element={<PrivateRoute><RadioStationCategoryAddEdit /></PrivateRoute>}></Route>
            {/* Radio Station end */}

            {/* Plans start */}
            <Route path="/inapp-purchase" element={<PrivateRoute>   <PurchasePlan /> </PrivateRoute>} ></Route>
            <Route path="/edit-inapp-purchase/:id" element={<PrivateRoute> <EditPurchasePlan /> </PrivateRoute>} ></Route>
            <Route path="/add-inapp-purchase" element={<PrivateRoute>   <EditPurchasePlan /> </PrivateRoute>} ></Route>
            <Route path="/idea-biz" element={<PrivateRoute>   <Ideatobill /> </PrivateRoute>} ></Route>
            <Route path="/edit-idea-biz/:id" element={<PrivateRoute> <EditIdeatobill /> </PrivateRoute>} ></Route>
            <Route path="/add-idea-biz" element={<PrivateRoute>   <EditIdeatobill /> </PrivateRoute>} ></Route>
            <Route path="/google-product-ppv-manager" element={<PrivateRoute>   <GoogleProductPPVManager /> </PrivateRoute>} ></Route>
            <Route path="/edit-google-product-ppv/:id" element={<PrivateRoute> <EditGoogleProductPPV /> </PrivateRoute>} ></Route>
            <Route path="/add-google-product-ppv" element={<PrivateRoute>   <EditGoogleProductPPV /> </PrivateRoute>} ></Route>
            <Route path="/devices" element={<PrivateRoute><Devices /></PrivateRoute>} ></Route>
            <Route path="/life-time-subscription" element={<PrivateRoute>   <LifeTimeSubcription /></PrivateRoute>}  ></Route>
            <Route path="/add-subscription-plans" element={<PrivateRoute> <AddSubscriptionPlan /></PrivateRoute>}  ></Route>
            <Route path="/preview-subscription-plan/:id" element={<PrivateRoute> <AddSubscriptionPlan /></PrivateRoute>}  ></Route>
            <Route path="/subscription-plans" element={<PrivateRoute><SubscriptionPlan ></SubscriptionPlan> </PrivateRoute>}  ></Route>
            <Route path="/purchase-subscription" element={<PrivateRoute><PurchaseSubscription /></PrivateRoute>} />
            <Route path="/deployment-success" element={<PrivateRoute><DeploymentSuccess /></PrivateRoute>} />
            {/* Plans end */}
            <Route path="/donation-details" element={<PrivateRoute><DonationDetails /></PrivateRoute>} />
            <Route path="/donation-transactions" element={<PrivateRoute><DonationTransactions /></PrivateRoute>} />

            {/* Pages start */}
            <Route path="/pages" element={<PrivateRoute><AllPages /></PrivateRoute>} ></Route>
            <Route path="/edit-page/:id" element={<PrivateRoute> <AddPages /> </PrivateRoute>} ></Route>
            <Route path="/add-page" element={<PrivateRoute>  <AddPages /> </PrivateRoute>} ></Route>

            <Route path="/landing-page/index" element={<PrivateRoute>  <LandingPages /></PrivateRoute>} ></Route>
            <Route path="/add-landing-page" element={<PrivateRoute> <AddLandingPages /> </PrivateRoute>}></Route>
            <Route path="/edit-landing-page/:id" element={<PrivateRoute><AddLandingPages /> </PrivateRoute>}  ></Route>

            {/* Pages end */}

            {/* Seo start*/}

            <Route path="/faq" element={<PrivateRoute> <FAQ /> </PrivateRoute>}></Route>
            <Route path="/faq-category" element={<PrivateRoute><Faq_category /></PrivateRoute>} ></Route>
            <Route path="/add-faq-category" element={<PrivateRoute> <Add_Faq_category /> </PrivateRoute>}></Route>
            <Route path="/edit-faq-category/:id" element={<PrivateRoute>  <Add_Faq_category /> </PrivateRoute>} ></Route>
            {/* Seo end */}



            {/* Menu start */}
            <Route path="/menu" element={<PrivateRoute><Menu /></PrivateRoute>} ></Route>
            <Route path="/addmenu" element={<PrivateRoute><MenuAddUpdate /></PrivateRoute>} ></Route>
            <Route path="/editmenu/:id" element={<PrivateRoute><MenuAddUpdate /></PrivateRoute>}  ></Route>
            <Route path="/sidebarmenu" element={<PrivateRoute><SidebarMenu /></PrivateRoute>}  ></Route>
            <Route path="/addsidebarmenu" element={<PrivateRoute><SidebarMenuAddUpdate /></PrivateRoute>}  ></Route>
            <Route path="/editsidebarmenu/:id" element={<PrivateRoute><SidebarMenuAddUpdate /></PrivateRoute>}  ></Route>
            <Route path="/footermenu" element={<PrivateRoute><FooterMenu /></PrivateRoute>}></Route>
            <Route path="/addfootermenu" element={<PrivateRoute><FooterAddUpdate /></PrivateRoute>}></Route>
            <Route path="/editfootermenu/:id" element={<PrivateRoute><FooterAddUpdate /></PrivateRoute>}></Route>
            <Route path="/mobilemenu" element={<PrivateRoute><MobileMenu /></PrivateRoute>}  ></Route>
            <Route path="/addmobilemenu" element={<PrivateRoute><MobileMenuAddUpdate /></PrivateRoute>}  ></Route>
            <Route path="/editmobilemenu/:id" element={<PrivateRoute><MobileMenuAddUpdate /></PrivateRoute>}  ></Route>
            <Route path="/tvmenu" element={<PrivateRoute><TVMenu /></PrivateRoute>}  ></Route>
            <Route path="/addtvmenu" element={<PrivateRoute><TVMenuAddUpdate /></PrivateRoute>}  ></Route>
            <Route path="/edittvmenu/:id" element={<PrivateRoute><TVMenuAddUpdate /></PrivateRoute>}  ></Route>
            <Route path="/addtvsidebarmenu" element={<PrivateRoute><TVSidebarMenuAddUpdate /></PrivateRoute>}  ></Route>
            <Route path="/edittvsidebarmenu/:id" element={<PrivateRoute><TVSidebarMenuAddUpdate /></PrivateRoute>}  ></Route>
            {/* Menu end */}


            {/* StoreFront settings start */}
            <Route path="/site/redis-setting" element={<PrivateRoute><RedisSetting /></PrivateRoute>}  ></Route>
            <Route path="/site/transcoding-setting" element={<PrivateRoute><Transcoding_Setting /></PrivateRoute>}></Route>
            <Route path="/transcoding-failed-jobs" element={<PrivateRoute><TranscodingFailed /></PrivateRoute>}></Route>
            <Route path="/transcoding-jobs" element={<PrivateRoute><TranscodingJobs /></PrivateRoute>}></Route>
            <Route path="/epg-settings" element={<PrivateRoute><EPGSettings /></PrivateRoute>}></Route>
            <Route path="/site/content-classification" element={<PrivateRoute><ContentClassification /></PrivateRoute>}></Route>
            <Route path="/partner-settings" element={<PrivateRoute><PartnerSettings /></PrivateRoute>}></Route>

            <Route path="/site/loginpage-setting" element={<PrivateRoute>   <Loginpage_Setting  ></Loginpage_Setting></PrivateRoute>}  ></Route>
            <Route path="/site/mobile-deep-linking" element={<PrivateRoute><MobileDeepLinkingSettings setApiresponsealert={setApiresponsealert} setShowalert={setShowalert} /></PrivateRoute>} />
            <Route path="/site/rtmpurl" element={<PrivateRoute><Rtmpurl /></PrivateRoute>} ></Route>
            {userRole === "5" && (
              <Route path="/storage_settings" element={<PrivateRoute> <StorageSettings /> </PrivateRoute>} ></Route>
            )}

            {/* StoreFront settings end */}

            <Route path="/signup-menu" element={<PrivateRoute><SignupMenu /></PrivateRoute>}  ></Route>
            <Route path="/partner-signup-menu" element={<PrivateRoute><PartnerSignupMenu /></PrivateRoute>} ></Route>
            <Route path="/sliders" element={<PrivateRoute>  <Slider /> </PrivateRoute>}  ></Route>
            <Route path="/addslider" element={<PrivateRoute>   <SliderAddUpdate ></SliderAddUpdate> </PrivateRoute>} ></Route>
            <Route path="/editslider/:id" element={<PrivateRoute>  <SliderAddUpdate /> </PrivateRoute>}   ></Route>

            {/* Payment settings start*/}
            <Route path="/payment_settings" element={<PrivateRoute><PaymentSettings /></PrivateRoute>} ></Route>
            <Route path="/stripe_settings" element={<PrivateRoute><Stripe /></PrivateRoute>} ></Route>
            <Route path="/pesapel_settings" element={<PrivateRoute><Pesapal /></PrivateRoute>} ></Route>
            <Route path="/razorpay_settings" element={<PrivateRoute><Razorpay /></PrivateRoute>}  ></Route>
            <Route path="/payhere-settings" element={<PrivateRoute><Payhere /></PrivateRoute>}  ></Route>
            <Route path="/cashfree_settings" element={<PrivateRoute><Cashfree /></PrivateRoute>}  ></Route>
            <Route path="/cashfree-easy-split" element={<PrivateRoute><CashfreeEasySplit /></PrivateRoute>}  ></Route>
            <Route path="/googlepay_settings" element={<PrivateRoute><GooglePay /></PrivateRoute>}  ></Route>
            <Route path="/applepay_settings" element={<PrivateRoute><ApplePay /></PrivateRoute>}  ></Route>
            <Route path="/ideabiz_settings" element={<PrivateRoute><Ideabiz /></PrivateRoute>}  ></Route>
            {/* Payment settings end */}

            {/* PPV Purchase Plans Management */}
            <Route path="/admin/ppv-purchase-plans" element={<PrivateRoute><PPVPurchasePlansList /></PrivateRoute>}></Route>
            <Route path="/admin/ppv-purchase-plans/create" element={<PrivateRoute><AddPPVPurchasePlans /></PrivateRoute>}></Route>
            <Route path="/admin/ppv-purchase-plans/edit/:id" element={<PrivateRoute><AddPPVPurchasePlans /></PrivateRoute>}></Route>
            {/* PPV Purchase Plans Management end */}

            {/* Region Management */}
            <Route path="/admin-regions" element={<PrivateRoute><RegionList /></PrivateRoute>}></Route>
            <Route path="/admin-add-region" element={<PrivateRoute><RegionAddUpdate /></PrivateRoute>}></Route>
            <Route path="/admin-edit-region/:id" element={<PrivateRoute><RegionAddUpdate /></PrivateRoute>}></Route>

            {/* Language settings */}
            <Route path="/admin-languages" element={<PrivateRoute><VideoLanguage /></PrivateRoute>}  ></Route>
            <Route path="/admin-add-language" element={<PrivateRoute><LanguageAddUpdate /></PrivateRoute>}  ></Route>
            <Route path="/admin-edit-language/:id" element={<PrivateRoute><LanguageAddUpdate /></PrivateRoute>}  ></Route>

            <Route
              path="/admin-editlanguages/:id"
              element={<PrivateRoute>
                <EditVideoLanguage
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></EditVideoLanguage>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/translate-languages"
              element={<PrivateRoute>
                <ManageTranslation
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></ManageTranslation>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/edit-translate-language/:id"
              element={<PrivateRoute>
                <EditTranslationLanguage setApiresponsealert={setApiresponsealert} setShowalert={setShowalert}></EditTranslationLanguage>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/subtitlelanguage"
              element={<PrivateRoute>
                <SubtitleLanguage
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></SubtitleLanguage>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/edit-subtitlelanguage/:id"
              element={<PrivateRoute>
                <EditSubtitleLanguage
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></EditSubtitleLanguage>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/translate-languages-index"
              element={<PrivateRoute>
                <ManageTranslationLanguage
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></ManageTranslationLanguage>
              </PrivateRoute>}
            ></Route>


            {/* Settings start */}
            <Route path="/currency_settings" element={<PrivateRoute>  <CurrencySettings setApiresponsealert={setApiresponsealert} setShowalert={setShowalert}  ></CurrencySettings> </PrivateRoute>}  ></Route>
            {/* Settings end */}
            <Route
              path="/admin/channel/add-new-videos"
              element={<PrivateRoute>
                <AddNewVideo
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></AddNewVideo>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/admin/channel/video-categories"
              element={<PrivateRoute>
                <ManageVideoCategories
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></ManageVideoCategories>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/admin/channel/add-video-category"
              element={<PrivateRoute>
                <AddManageVideoCategory
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></AddManageVideoCategory>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/admin/channel/series-lists"
              element={<PrivateRoute>
                <SeriesLists
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></SeriesLists>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/admin/channel/add-new-series"
              element={<PrivateRoute>
                <AddNewSeries
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></AddNewSeries>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/admin/channel/audio-lists"
              element={<PrivateRoute>
                <AudioLists
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></AudioLists>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/admin/channel/add-new-audio"
              element={<PrivateRoute>
                <AddnewAudios
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></AddnewAudios>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/admin/channel/manage-audio-category"
              element={<PrivateRoute>
                <ManageAudioCategories
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></ManageAudioCategories>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/admin/channel/add-category"
              element={<PrivateRoute>
                <AddCategory
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></AddCategory>
              </PrivateRoute>}
            ></Route>

            <Route
              path="/admin/channel/add-albums"
              element={<PrivateRoute>
                <Addalbums
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Addalbums>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/admin/channel/all-livevideos"
              element={<PrivateRoute>
                <AllLiveVideo
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></AllLiveVideo>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/admin/channel/add-newlive-video"
              element={<PrivateRoute>
                <AddNewLiveVideo
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></AddNewLiveVideo>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/admin/channel/manage-live-category"
              element={<PrivateRoute>
                <ManageLiveVideoCategories
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></ManageLiveVideoCategories>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/admin/channel/add-manage-live-category"
              element={<PrivateRoute>
                <AddManageCategories
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></AddManageCategories>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/admin/channel/manage-live-event"
              element={<PrivateRoute>
                <ManageLiveEvent
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></ManageLiveEvent>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/admin/channel/add-manage-live-event"
              element={<PrivateRoute>
                <AddManageLiveEvent
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></AddManageLiveEvent>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/admin/channel/mychannel-settings"
              element={<PrivateRoute>
                <MyChannelSettings
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></MyChannelSettings>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/admin/channel/video-analytics"
              element={<PrivateRoute>
                <VideoAnalytics
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></VideoAnalytics>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/admin/channel/video-region"
              element={<PrivateRoute>
                <VideoViewRegion
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></VideoViewRegion>
              </PrivateRoute>}
            ></Route>
            {/* <Route
                path="/admin/channel/payouts"
                element={<PrivateRoute>
                  <Payouts
                    setApiresponsealert={setApiresponsealert}
                    setShowalert={setShowalert}
                  ></Payouts>
              </PrivateRoute>  }
              ></Route> */}

            {/* ContentPartner */}
            <Route
              path="/admin/content/dashboard"
              element={<PrivateRoute>
                <Dash_Board
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Dash_Board>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/admin/content/all-videos"
              element={<PrivateRoute>
                <All_Videos
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></All_Videos>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/admin/content/add-newvideos"
              element={<PrivateRoute>
                <Add_NewVideos
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Add_NewVideos>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/admin/content/manage-video-category"
              element={<PrivateRoute>
                <Manage_VideoCategories
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Manage_VideoCategories>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/admin/content/add-manage-video-category"
              element={<PrivateRoute>
                <AddManage_VideoCategories
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></AddManage_VideoCategories>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/admin/content/audio-lists"
              element={<PrivateRoute>
                <Audio_Lists
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Audio_Lists>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/admin/content/add-newaudio-lists"
              element={<PrivateRoute>
                <Add_NewAudios
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Add_NewAudios>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/admin/content/manage-audio-category"
              element={<PrivateRoute>
                <Manage_AudioCategories
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Manage_AudioCategories>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/admin/content/add-category"
              element={<PrivateRoute>
                <Add_category
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Add_category>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/admin/content/manage-albums"
              element={<PrivateRoute>
                <Manage_Albums
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Manage_Albums>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/admin/content/add-manage-albums"
              element={<PrivateRoute>
                <Add_Albums
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Add_Albums>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/admin/content/all-livevideo"
              element={<PrivateRoute>
                <All_LiveVideo
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></All_LiveVideo>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/admin/content/add-new-livevideo"
              element={<PrivateRoute>
                <Add_NewLiveVideo
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Add_NewLiveVideo>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/admin/content/manage-live-videocategory"
              element={<PrivateRoute>
                <Manage_LiveCategory
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Manage_LiveCategory>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/admin/content/add-manage-live-category"
              element={<PrivateRoute>
                <Add_manageLiveCategory
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Add_manageLiveCategory>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/admin/content/manage-live-event"
              element={<PrivateRoute>
                <Manage_LiveEvent
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Manage_LiveEvent>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/admin/content/add-manage-live-event"
              element={<PrivateRoute>
                <Add_ManageLiveEvent
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Add_ManageLiveEvent>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/admin/content/video-analytics"
              element={<PrivateRoute>
                <Video_Analytics
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Video_Analytics>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/admin/content/video-view-region"
              element={<PrivateRoute>
                <Video_ViewRegion
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Video_ViewRegion>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/admin/content/video-payout"
              element={<PrivateRoute>
                <Video_Payout
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Video_Payout>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/admin/content/live-stream-payout"
              element={<PrivateRoute>
                <Live_StreamPayout
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Live_StreamPayout>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/admin/content/all-pages"
              element={<PrivateRoute>
                <All_pages
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></All_pages>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/admin/content/add-pages"
              element={<PrivateRoute>
                <Add_pages
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Add_pages>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/admin/content/about-myprofile"
              element={<PrivateRoute>
                <About_MyProfile
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></About_MyProfile>
              </PrivateRoute>}
            ></Route>

            {/* video */}

            <Route
              path="/media-library"
              element={<PrivateRoute>
                <Media_Library
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Media_Library>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/view-library/:id"
              element={<PrivateRoute>
                <View_Media_Library
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></View_Media_Library>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/libraries"
              element={<PrivateRoute>
                <Main
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Main>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/content-video/:id"
              element={<PrivateRoute>
                <ContentVideo
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></ContentVideo>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/content-live/:id"
              element={<PrivateRoute>
                <ContentLive
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></ContentLive>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/content-audio/:id"
              element={<PrivateRoute>
                <ContentAudio
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></ContentAudio>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/content-series/:id"
              element={<PrivateRoute>
                <ContentSeries
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></ContentSeries>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/videos/editvideo/:id"
              element={<PrivateRoute>
                <EditVideotag
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></EditVideotag>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/video-for-approval"
              element={<PrivateRoute>
                <Videoforapproval
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Videoforapproval>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/master-list"
              element={<PrivateRoute>
                <Mastervideolist
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Mastervideolist>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/video-schedule"
              element={<PrivateRoute>
                <Videoschedule
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Videoschedule>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/add-schedule"
              element={<PrivateRoute>
                <AddVideoschedule
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></AddVideoschedule>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/edit-schedule/:id"
              element={<PrivateRoute>
                <EditVideoschedule
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></EditVideoschedule>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/manage/schedule/:id"
              element={<PrivateRoute>
                <EditManageCalendarschedule
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></EditManageCalendarschedule>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/manage-schedule/:id"
              element={<PrivateRoute>
                <Manageschedule
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Manageschedule>
              </PrivateRoute>}
            ></Route>




            {/* Live stream */}

            <Route
              path="/live-event-artist"
              element={<PrivateRoute>
                <LiveEventArtist
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></LiveEventArtist>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/add-live-event-artist"
              element={<PrivateRoute>
                <AddLiveEventArtist
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></AddLiveEventArtist>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/live-event-artist-edit/:id"
              element={<PrivateRoute>
                <EditLiveEventArtist
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></EditLiveEventArtist>
              </PrivateRoute>}
            ></Route>


            {/* Audio */}

            {/* Accounts */}


            <Route
              path="/MultiUser-limit"
              element={<PrivateRoute>
                <MultiUserManagement
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></MultiUserManagement>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/channel-partner-signup-menu"
              element={<PrivateRoute>
                <ChannelPartnerSignupMenu
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></ChannelPartnerSignupMenu>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/content-partner-signup-menu"
              element={<PrivateRoute>
                <ContentPartnerSignupMenu
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></ContentPartnerSignupMenu>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/filemanager"
              element={<PrivateRoute>
                <FileManager
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></FileManager>
              </PrivateRoute>}
            ></Route>



            <Route path="/tv-playouts" element={<PrivateRoute><Tvplayouts setApiresponsealert={setApiresponsealert} setShowalert={setShowalert}></Tvplayouts></PrivateRoute>}></Route>
            <Route path="/edit/tv-playouts/:id" element={<PrivateRoute> <EditTvplayouts setApiresponsealert={setApiresponsealert} setShowalert={setShowalert}></EditTvplayouts></PrivateRoute>}></Route>
            <Route path="/playout-logs" element={<PrivateRoute> <PlayoutLogs setApiresponsealert={setApiresponsealert} setShowalert={setShowalert}></PlayoutLogs></PrivateRoute>}></Route>


            {/* Site */}
            <Route
              path="/players"
              element={<PrivateRoute>
                <Player
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Player>
              </PrivateRoute>}
            ></Route>

            {/* Ads Management */}


            <Route
              path="/edit-subscription-plans/:id"
              element={<PrivateRoute>
                <EditSubscriptionPlan
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></EditSubscriptionPlan>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/payment/total_revenue"
              element={<PrivateRoute>
                <TotalRevenue
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></TotalRevenue>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/payment/subscription"
              element={<PrivateRoute>
                <SubcriptionPayment
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></SubcriptionPayment>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/payment/subscription-view/:id"
              element={<PrivateRoute>
                <ViewSubcription
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></ViewSubcription>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/payment/payPerView"
              element={<PrivateRoute>
                <PayperviewPayments
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></PayperviewPayments>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/payment/payPerView-view/:id"
              element={<PrivateRoute>
                <ViewPayperview
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></ViewPayperview>
              </PrivateRoute>}
            ></Route>

            <Route
              path="/analytics/users"
              element={<PrivateRoute>
                <UsersAnalytics
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></UsersAnalytics>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/users/revenue"
              element={<PrivateRoute>
                <UsersRevenue
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></UsersRevenue>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/video/purchased-analytics"
              element={<PrivateRoute>
                <PurchaseVideoAnalytics
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></PurchaseVideoAnalytics>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/cpp/analytics"
              element={<PrivateRoute>
                <CPPAnalytics
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></CPPAnalytics>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/cpp/video-analytics"
              element={<PrivateRoute>
                <CPPVideoAnalytics
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></CPPVideoAnalytics>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/cpp/revenue"
              element={<PrivateRoute>
                <CPPRevenue
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></CPPRevenue>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/analytics/ViewsRegion"
              element={<PrivateRoute>
                <ViewRegion
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></ViewRegion>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/analytics/RevenueRegion"
              element={<PrivateRoute>
                <RevenueRegion
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></RevenueRegion>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/analytics/PlayerVideoAnalytics"
              element={<PrivateRoute>
                <PlayerVideoAnalytics
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></PlayerVideoAnalytics>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/analytics/RegionVideoAnalytics"
              element={<PrivateRoute>
                <RegionVideoAnalytics
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></RegionVideoAnalytics>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/analytics/PlayerUserAnalytics"
              element={<PrivateRoute>
                <PlayerUserAnalytics
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></PlayerUserAnalytics>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/analytics/livestream-analytics"
              element={<PrivateRoute>
                <CPPLiveVideo
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></CPPLiveVideo>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/live/purchased-analytics"
              element={<PrivateRoute>
                <LiveStreamAnalytics
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></LiveStreamAnalytics>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/analytics/player"
              element={<PrivateRoute>
                <PlayerAnalytics
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></PlayerAnalytics>
              </PrivateRoute>}
            ></Route>

            <Route
              path="/settings"
              element={<PrivateRoute>
                <StorefrontSettings
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></StorefrontSettings>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/labels"
              element={<PrivateRoute>
                <Main_labels
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Main_labels>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/label-store-label"
              element={<PrivateRoute>
                <Labelsstorelabels
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Labelsstorelabels>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/label/:id"
              element={<PrivateRoute>
                <Label_source
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Label_source>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/site/signup-avatars"
              element={<PrivateRoute>
                <Signup_avatars
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Signup_avatars>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/site/site-setting"
              element={<PrivateRoute>
                <Site_Setting
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Site_Setting>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/site/push-notification"
              element={<PrivateRoute>
                <PushNotification
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></PushNotification>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/site/livekit-configuration"
              element={<PrivateRoute>
                <LivekitConfiguration
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></LivekitConfiguration>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/site/ppv-setting"
              element={<PrivateRoute>
                <Ppv_Setting
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Ppv_Setting>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/site/video-setting"
              element={<PrivateRoute>
                <Video_Setting
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Video_Setting>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/site/search-setting"
              element={<PrivateRoute>
                <Search_Setting
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Search_Setting>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/site/registration-setting"
              element={<PrivateRoute>
                <Registration_Setting
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Registration_Setting>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/site/email-setting"
              element={<PrivateRoute>
                <Email_Setting
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Email_Setting>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/site/social-network-setting"
              element={<PrivateRoute>
                <Social_Network_Setting
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Social_Network_Setting>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/site/series-setting"
              element={<PrivateRoute>
                <Series_Setting
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Series_Setting>
              </PrivateRoute>}
            ></Route>

            <Route
              path="/site/advertisement-setting"
              element={<PrivateRoute>
                <Advertisement_Setting
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Advertisement_Setting>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/site/app-setting"
              element={<PrivateRoute>
                <App_Setting
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></App_Setting>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/site/script-setting"
              element={<PrivateRoute>
                <Script_Setting
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Script_Setting>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/site/default-image-setting"
              element={<PrivateRoute>
                <Default_Image_Setting
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Default_Image_Setting>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/site/payouts-setting"
              element={<PrivateRoute>
                <Payouts_Setting
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Payouts_Setting>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/site/recaptcha-setting"
              element={<PrivateRoute>
                <Recaptcha_Setting
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Recaptcha_Setting>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/site/timezone-setting"
              element={<PrivateRoute>
                <Timezone_Setting
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Timezone_Setting>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/site/geo-fencing-setting"
              element={<PrivateRoute>
                <Manage_Geo_Fencing
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Manage_Geo_Fencing>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/site/slider-setting"
              element={<PrivateRoute>
                <Slider_Setting
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Slider_Setting>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/home-settings"
              element={<PrivateRoute>
                <HomePageSettings
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></HomePageSettings>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/edit-orderhome/:id"
              element={<PrivateRoute>
                <Editorderhome
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Editorderhome>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/linking_settings"
              element={<PrivateRoute>
                <LinkSettings
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></LinkSettings>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/age/index"
              element={<PrivateRoute>
                <ManageAge
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></ManageAge>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/add-age"
              element={<PrivateRoute>
                <AddManageAge
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></AddManageAge>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/edit/manage-age/:id"
              element={<PrivateRoute>
                <EditManageAge
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></EditManageAge>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/email_settings"
              element={<PrivateRoute>
                <EmailSettings
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></EmailSettings>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/email-logs"
              element={<PrivateRoute>
                <EmaiLogs
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></EmaiLogs>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/Iyzico_settings"
              element={<PrivateRoute>
                <Iyzico
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Iyzico>
              </PrivateRoute>}
            ></Route>

            <Route
              path="/paypal_settings"
              element={<PrivateRoute>
                <Paypal
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Paypal>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/edit-template-email/:id"
              element={<PrivateRoute>
                <EmailSettingsTemplate
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></EmailSettingsTemplate>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/template-email/view/:id"
              element={<PrivateRoute>
                <ViewTemplate
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></ViewTemplate>
              </PrivateRoute>}
            ></Route>

            <Route
              path="/mobileappscreen"
              element={<PrivateRoute>
                <MobileSettings
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></MobileSettings>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/mobileapp/splash/edit/:id"
              element={<PrivateRoute>
                <EditSplashMobileSettings
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></EditSplashMobileSettings>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/mobileapp/edit/:id"
              element={<PrivateRoute>
                <EditMobileSettings
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></EditMobileSettings>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/system_settings"
              element={<PrivateRoute>
                <SocialLoginSettings
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></SocialLoginSettings>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/edit_currency_settings"
              element={<PrivateRoute>
                <CurrencySettings
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></CurrencySettings>
              </PrivateRoute>}
            ></Route>

            <Route
              path="/update_currency_settings/:id"
              element={<PrivateRoute>
                <UpdateCurrencySettings
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></UpdateCurrencySettings>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/revenue_settings/index"
              element={<PrivateRoute>
                <RevenueSettings
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></RevenueSettings>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/ThumbnailSetting"
              element={<PrivateRoute>
                <ThumbnailSettings
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></ThumbnailSettings>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/ChooseProfileScreen"
              element={<PrivateRoute>
                <ProfileScreen
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></ProfileScreen>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/ThemeIntegration"
              element={<PrivateRoute>
                <Theme
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Theme>
              </PrivateRoute>}
            ></Route>


            <Route
              path="/compress-image-setting"
              element={<PrivateRoute>
                <ImageSettings
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></ImageSettings>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/pop-up-setting"
              element={<PrivateRoute>
                <PopupSettings
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></PopupSettings>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/comment-section-setting"
              element={<PrivateRoute>
                <CommentSetting
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></CommentSetting>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/apps"
              element={<PrivateRoute>
                <Apps
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Apps>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/site-meta-settings"
              element={<PrivateRoute>
                <Site_met_settings
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Site_met_settings>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/update_sitemeta_settings/:id"
              element={<PrivateRoute>
                <Update_Site_met_settings
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Update_Site_met_settings>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/tv-settings"
              element={<PrivateRoute>
                <Tv_Settings
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Tv_Settings>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/update_tvsetting/:id"
              element={<PrivateRoute>
                <Update_Tv_Settings
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Update_Tv_Settings>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/dsp-settings"
              element={<PrivateRoute>
                <Dsp_Settings
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Dsp_Settings>
              </PrivateRoute>}
            ></Route>

            <Route
              path="/advertisers"
              element={<PrivateRoute>
                <AdvertiserList
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></AdvertiserList>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/editadvertiser/:id"
              element={<PrivateRoute>
                <EditAdvertiser
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></EditAdvertiser>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/edit_ads_list/:id"
              element={<PrivateRoute>
                <EditAdsList
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></EditAdsList>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/ads_categories"
              element={<PrivateRoute>
                <AdsCategories
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></AdsCategories>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/edit_ads_categories/:id"
              element={<PrivateRoute>
                <EditAdsCategories
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></EditAdsCategories>
              </PrivateRoute>}
            ></Route>

            <Route
              path="/advertisement-subscription-plans"
              element={<PrivateRoute>
                <AdsPlan
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></AdsPlan>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/create-advertisement-plan"
              element={<PrivateRoute>
                <AddAdsPlan
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></AddAdsPlan>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/preview-ads-subscription-plan/:id"
              element={<PrivateRoute>
                <AddAdsPlan
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></AddAdsPlan>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/ads_revenue"
              element={<PrivateRoute>
                <AdsRevenue
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></AdsRevenue>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/ads-monetization"
              element={<PrivateRoute>
                <AdsMonetization
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></AdsMonetization>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/calender"
              element={<PrivateRoute>
                <CalenderEvent
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></CalenderEvent>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/ads_campaigns"
              element={<PrivateRoute>
                <AdsCampaigns
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></AdsCampaigns>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/ads-time-slot"
              element={<PrivateRoute>
                <AdsTimeSlot
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></AdsTimeSlot>
              </PrivateRoute>}
            ></Route>

            {/* Geo_Fencing */}
            <Route
              path="/Geofencing"
              element={<PrivateRoute>
                <ManageGeoFencing
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></ManageGeoFencing>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/countries"
              element={<PrivateRoute>
                <ManageCountry
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></ManageCountry>
              </PrivateRoute>}
            ></Route>
            {/* Configuration */}
            <Route
              path="/clear_cache"
              element={<PrivateRoute>
                <CacheManagement
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></CacheManagement>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/debug"
              element={<PrivateRoute>
                <Debug
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Debug>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/plugins"
              element={<PrivateRoute>
                <PluginsManagement
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></PluginsManagement>
              </PrivateRoute>}
            ></Route>
            {/* Custom Fields */}
            <Route path="/custom-fields/dashboard" element={<PrivateRoute><CustomFieldsDashboard /></PrivateRoute>} />
            <Route path="/custom-fields" element={<PrivateRoute><FieldsList /></PrivateRoute>} />
            <Route path="/custom-fields/create" element={<PrivateRoute><FieldFormEnhanced /></PrivateRoute>} />
            <Route path="/custom-fields/edit/:id" element={<PrivateRoute><FieldFormEnhanced /></PrivateRoute>} />
            <Route path="/custom-fields/assign" element={<PrivateRoute><AssignFields /></PrivateRoute>} />
            <Route path="/custom-fields/sets" element={<PrivateRoute><FieldSetsList /></PrivateRoute>} />
            <Route path="/custom-fields/sets/create" element={<PrivateRoute><FieldSetForm /></PrivateRoute>} />
            <Route path="/custom-fields/sets/edit/:id" element={<PrivateRoute><FieldSetForm /></PrivateRoute>} />
            <Route path="/custom-fields/conditions" element={<PrivateRoute><Conditions /></PrivateRoute>} />
            {/* Push Notification Management */}
            <Route path="/push-notification-lists" element={<PrivateRoute><PushNotificationList setApiresponsealert={setApiresponsealert} setShowalert={setShowalert} /></PrivateRoute>} />
            <Route path="/add-push-notification" element={<PrivateRoute><AddPushNotification setApiresponsealert={setApiresponsealert} setShowalert={setShowalert} /></PrivateRoute>} />
            <Route path="/edit-push-notification/:id" element={<PrivateRoute><AddPushNotification setApiresponsealert={setApiresponsealert} setShowalert={setShowalert} /></PrivateRoute>} />

            {/* UGC Management */}
            <Route path="/ugc-list" element={<PrivateRoute><UGCIndex /></PrivateRoute>} />
            <Route path="/ugc/pending" element={<PrivateRoute><UGCPending /></PrivateRoute>} />

            {/* Contact Us */}
            <Route
              path="/contact-us"
              element={<PrivateRoute>
                <ContactRequest
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></ContactRequest>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/contact-us/preview/:id"
              element={<PrivateRoute>
                <PreviewContact />
              </PrivateRoute>}
            ></Route>
            {/* Log Activity */}
            <Route
              path="/logActivity"
              element={<PrivateRoute>
                <SeeLogActivity
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></SeeLogActivity>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/terms-and-conditions"
              element={<PrivateRoute>
                <Terms_and_condition
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Terms_and_condition>
              </PrivateRoute>}
            ></Route>
            <Route
              path="/privacy-policy"
              element={<PrivateRoute>
                <Privacy_policy
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></Privacy_policy>
              </PrivateRoute>}
            ></Route>
            <Route path="/music-settings" element={<PrivateRoute><MusicSettings /></PrivateRoute>} />
            <Route path="*" element={<Error404></Error404>}></Route>
            <Route
              path="/translate-index"
              element={<PrivateRoute>
                <ManageTranslationVer
                  setApiresponsealert={setApiresponsealert}
                  setShowalert={setShowalert}
                ></ManageTranslationVer>
              </PrivateRoute>}
            ></Route>

            {/* Super admin page */}
            <Route path="/library-setting" element={<PrivateRoute><Library_Setting setApiresponsealert={setApiresponsealert} setShowalert={setShowalert}></Library_Setting></PrivateRoute>}            ></Route>
            <Route path="/product-type-settings" element={<PrivateRoute> <ProductTypeSetting setApiresponsealert={setApiresponsealert} setShowalert={setShowalert}></ProductTypeSetting> </PrivateRoute>}></Route>
            <Route path="/playout-settings" element={<PrivateRoute> <Playoutsetting setApiresponsealert={setApiresponsealert} setShowalert={setShowalert}></Playoutsetting></PrivateRoute>}></Route>
            <Route path="/payment-gateways-settings" element={<PrivateRoute> <PaymentGatewaysSettings setApiresponsealert={setApiresponsealert} setShowalert={setShowalert}></PaymentGatewaysSettings></PrivateRoute>}></Route>
          </Route>
        </Routes>
      </Suspense >

    </>
  );
}

export default AllRoutes;
